import 'antd/dist/antd.css';

import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Form,
  Input,
  Message,
  Switch,
  Table,
} from '@alifd/next';
import { Select } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import ReactDragListView from 'react-drag-listview'; //拖曳功能
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';
const Option = Select.Option;
const { Item } = Form;
const { RangePicker } = DatePicker;

const ResidentBaAuthList = (props) => {
  const residentAccountNumbers = client.service('residentAccountNumbers'); //住戶
  const baDevice = client.service('baDevice'); //ba裝置
  const cardManagementGroup = client.service('cardManagementGroup'); //門禁權限群組

  //residentAccountNumbers Table
  const [residentDataArr, setResidentDataArr] = useState([]);

  //cardManagementGroup Table
  const [cardGroupDataArr, setCardGroupDataArr] = useState([]);

  //baDevice Table (門禁)
  const [baDeviceArr, setBaDeviceArr] = useState([]);

  //baDevice Table (電梯)
  const [baDeviceEleArr, setBaDeviceEleArr] = useState([]);

  //權限群組編輯Dialog UI開關
  const [authGroupDialog, setAuthGroupDialog] = useState(false);

  //群組UI for 權限群組編輯/住戶權限編輯
  const [editMode, setEditMode] = useState(true);

  //權限群組編輯Dialog 編輯(obj)||新增({})
  const [editAuthGroupStage, setEditAuthGroupStage] = useState({});

  //住戶群組編輯Dialog UI開關
  const [houseAuthDialog, setHouseAuthDialog] = useState(false);

  //住戶群組編輯(棟別編輯器) - 棟別Array
  const [houseBuild, setHouseBuild] = useState([]);

  //住戶群組編輯(棟別編輯器) 新增/移除模式 - true:新增, false:移除
  const [houseBuildEditMode, setHouseBuildEditMode] = useState(true);
  const [newOutArr, setNewOutArr] = useState([]);

  function parseHouseBuild() {
    //棟別選擇器 轉換 eg:[{label:A,value:'^A'},...]
    const hArrs = [...residentDataArr].map((i) => {
      return i.householdNumber.split('-')[0] || '';
    });
    let OutArr = hArrs.filter(
      (i, pos) => i.length > 0 && hArrs.indexOf(i) == pos
    );
    return OutArr.map((i) => {
      let obj = {};
      obj.label = i;
      obj.value = `^${i}`;
      return obj;
    });
  }

  function addHouseBuildDataParse() {
    //棟別一次綁定資料 parse 編輯資料(editAuthGroupStage)
    let outObj = {
      $addToSet: {},
      $set: {},
    };

    if (editAuthGroupStage.hasOwnProperty('cardGroups')) {
      outObj.$addToSet.cardGroups = { $each: editAuthGroupStage.cardGroups };
    }

    if (editAuthGroupStage.hasOwnProperty('doorAllows')) {
      outObj.$addToSet.doorAllows = { $each: editAuthGroupStage.doorAllows };
    }

    if (editAuthGroupStage.hasOwnProperty('doorAllowsObj')) {
      Object.keys(editAuthGroupStage.doorAllowsObj).forEach((e) => {
        //$set字串Object key:value改直
        let sstr = `doorAllowsObj.${e}`;
        let oobj = {};
        oobj[sstr] = editAuthGroupStage.doorAllowsObj[e];
        outObj.$set = Object.assign(outObj.$set, oobj);
      });
    }

    if (editAuthGroupStage.hasOwnProperty('elevatorAllows')) {
      outObj.$addToSet.elevatorAllows = {
        $each: editAuthGroupStage.elevatorAllows,
      };
    }

    if (editAuthGroupStage.hasOwnProperty('elevatorAllowsObj')) {
      Object.keys(editAuthGroupStage.elevatorAllowsObj).forEach((e) => {
        //$set字串Object key:value改直
        let sstr = `elevatorAllowsObj.${e}`;
        let oobj = {};
        oobj[sstr] = editAuthGroupStage.elevatorAllowsObj[e];
        outObj.$set = Object.assign(outObj.$set, oobj);
      });
    }

    // console.log(outObj);
    return outObj;
  }

  function removeHouseBuildDataParse() {
    //棟別一次綁定資料 parse 編輯資料(editAuthGroupStage)
    let outObj = {
      $pull: {},
      $unset: {},
    };

    if (editAuthGroupStage.hasOwnProperty('cardGroups')) {
      outObj.$pull.cardGroups = { $in: editAuthGroupStage.cardGroups };
    }

    if (editAuthGroupStage.hasOwnProperty('doorAllows')) {
      outObj.$pull.doorAllows = { $in: editAuthGroupStage.doorAllows };
    }

    if (editAuthGroupStage.hasOwnProperty('doorAllowsObj')) {
      Object.keys(editAuthGroupStage.doorAllowsObj).forEach((e) => {
        //$set字串Object key:value改直
        let sstr = `doorAllowsObj.${e}`;
        let oobj = {};
        oobj[sstr] = '';
        outObj.$unset = Object.assign(outObj.$unset, oobj);
      });
    }

    if (editAuthGroupStage.hasOwnProperty('elevatorAllows')) {
      outObj.$pull.elevatorAllows = { $in: editAuthGroupStage.elevatorAllows };
    }

    if (editAuthGroupStage.hasOwnProperty('elevatorAllowsObj')) {
      Object.keys(editAuthGroupStage.elevatorAllowsObj).forEach((e) => {
        //$set字串Object key:value改直
        let sstr = `elevatorAllowsObj.${e}`;
        let oobj = {};
        oobj[sstr] = '';
        outObj.$unset = Object.assign(outObj.$unset, oobj);
      });
    }

    // console.log(outObj);
    return outObj;
  }

  useEffect(() => {
    try {
      residentAccountNumbers.find({}).then((res) => {
        setResidentDataArr(res.data);
        const hArrs = [...res.data].map((i) => {
          return i.householdNumber.split('-')[0] || '';
        });
        let OutArr = hArrs.filter(
          (i, pos) => i.length > 0 && hArrs.indexOf(i) == pos
        );
        let newOutArr = OutArr.map((i) => {
          let obj = {};
          obj.label = i;
          obj.value = `^${i}`;
          return obj;
        });
        console.log(newOutArr, '===newOutArr');
        setNewOutArr(newOutArr);
      });
      cardManagementGroup.find({}).then((res) => {
        setCardGroupDataArr(res.data);
      });

      baDevice
        .find({
          query: {
            $or: [{ category: '門禁' }, { category: '電梯' }],
          },
        })
        .then((res) => {
          let doorDeviceArr = [];
          let eleDeviceArr = [];
          [...res.data].forEach((i) => {
            if (!i.text || !i.name || !i.category) return;
            let obj = {};
            obj.label = i.text;
            obj.value = i.name;
            if (i.category == '門禁') doorDeviceArr.push(obj);
            else if (i.category == '電梯') eleDeviceArr.push(obj);
          });
          //.filter((e)=>e!==false);
          setBaDeviceArr(doorDeviceArr);
          setBaDeviceEleArr(eleDeviceArr);
        });
    } catch (error) {
      console.log('未連接server:err', error);
    }
  }, [editAuthGroupStage]);

  return (
    <>
      {editMode === true ? (
        // 住戶權限編輯
        <div>
          <Button
            onClick={() => {
              setEditMode(false);
              setEditAuthGroupStage({}); //clear Dialog render Data
              setAuthGroupDialog(false); //Dialog UI control
              setHouseAuthDialog(false); //Dialog UI control
            }}
          >
            群組權限模式
          </Button>

          <Button
            onClick={() => {
              setEditAuthGroupStage({}); //clear Dialog render Data
              setHouseAuthDialog(true);
            }}
          >
            棟別集體編輯
          </Button>
          {/* 顯示住戶權限列表區 */}
          <Table dataSource={residentDataArr}>
            <Table.Column
              title="住戶戶號"
              width={50}
              cell={(record, index) => {
                return <>{residentDataArr[index].householdNumber}</>;
              }}
            />
            <Table.Column
              title="門禁權限"
              width={160}
              cell={(record, index) => {
                return (
                  <>
                    {residentDataArr[index].doorAllows
                      ? residentDataArr[index].doorAllows.map((list, ii) => {
                          return (
                            <p key={ii}>
                              {!residentDataArr[index].hasOwnProperty(
                                'doorAllowsObj'
                              ) ||
                              !residentDataArr[
                                index
                              ].doorAllowsObj.hasOwnProperty(list)
                                ? list
                                : residentDataArr[index].doorAllowsObj[list] ||
                                  list}
                            </p>
                          );
                        })
                      : ''}
                  </>
                );
              }}
            />
            <Table.Column
              title="電梯權限"
              width={160}
              cell={(record, index) => {
                return (
                  <>
                    {residentDataArr[index].elevatorAllows
                      ? residentDataArr[index].elevatorAllows.map(
                          (list, ii) => {
                            return (
                              <p key={ii}>
                                {!residentDataArr[index].hasOwnProperty(
                                  'elevatorAllowsObj'
                                ) ||
                                !residentDataArr[
                                  index
                                ].elevatorAllowsObj.hasOwnProperty(list)
                                  ? list
                                  : residentDataArr[index].elevatorAllowsObj[
                                      list
                                    ].name || list}
                              </p>
                            );
                          }
                        )
                      : ''}
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              width={30}
              lock="right"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div className={styles.btn}>
                    <Button
                      type="normal"
                      onClick={() => {
                        setEditAuthGroupStage(residentDataArr[index]);
                        setHouseAuthDialog(true);
                      }}
                    >
                      編輯權限
                    </Button>
                  </div>
                );
              }}
            ></Table.Column>
          </Table>

          {/* 編輯住戶門禁權限popup */}
          <Dialog
            hasMask
            className={styles.dialog}
            visible={houseAuthDialog}
            onOk={() => {
              if (
                !editAuthGroupStage.hasOwnProperty('doorAllows') &&
                !editAuthGroupStage.hasOwnProperty('elevatorAllows')
              ) {
                Swal.fire('錯誤!', '門禁與電梯權限欄位不能都為空', 'error');
                return;
              }

              if (editAuthGroupStage.hasOwnProperty('_id')) {
                //PATCH By id編輯單筆
                const tId = editAuthGroupStage._id;
                delete editAuthGroupStage._id;
                const sendDataObj = {
                  doorAllows: editAuthGroupStage.doorAllows,
                  doorAllowsObj: editAuthGroupStage.doorAllowsObj,
                  elevatorAllows: editAuthGroupStage.elevatorAllows,
                  elevatorAllowsObj: editAuthGroupStage.elevatorAllowsObj,
                  cardGroups: editAuthGroupStage.cardGroups,
                };
                residentAccountNumbers
                  .patch(tId, sendDataObj)
                  .then((data) => {
                    setHouseBuildEditMode(true); //棟別集體 新增/刪除 模式 reset
                    setHouseBuild([]); //Clear 棟別編輯 Array
                    setEditAuthGroupStage({}); //Dialog render Data
                    setHouseAuthDialog(false); //Dialog UI control
                    Swal.fire('修改成功!', '此權用戶限群改成功', 'success');
                  })
                  .catch((err) => {
                    Swal.fire('發生錯誤!', err.message || err, 'error');
                  });
                return;
              } else {
                //棟別編輯 加入權限
                if (houseBuild.length == 0) {
                  Swal.fire('缺少參數!', '目標棟別不得為空!', 'error');
                  return;
                }
                /**/
                residentAccountNumbers
                  .patch(
                    null,
                    houseBuildEditMode
                      ? addHouseBuildDataParse()
                      : removeHouseBuildDataParse(),
                    {
                      query: {
                        householdNumber: {
                          $regex: houseBuild.toString(),
                        },
                        // householdNumber:"A-1-1"
                      },
                    }
                  )
                  .then((data) => {
                    const newCardGroupDataArr = [...cardGroupDataArr].concat(
                      data
                    ); //前端表格渲染 更新
                    setCardGroupDataArr(newCardGroupDataArr);
                    setHouseBuildEditMode(true); //棟別集體 新增/刪除 模式 reset
                    setHouseBuild([]); //Clear 棟別編輯 Array
                    setEditAuthGroupStage({}); //Dialog render Data
                    setHouseAuthDialog(false); //Dialog UI control
                    Swal.fire('建立成功!', '此權限群組建立成功', 'success');
                    // location.reload();
                  })
                  .catch((err) => {
                    console.log(err);
                    Swal.fire('發生錯誤!', err.message || err, 'error');
                    // location.reload();
                  });
                /**/
              }
            }}
            onCancel={() => {
              setHouseBuildEditMode(true); //棟別集體 新增/刪除 模式 reset
              setHouseBuild([]); //Clear 棟別編輯 Array
              setEditAuthGroupStage({}); //Dialog render Data
              setHouseAuthDialog(false); //Dialog UI control
            }}
            onClose={() => {
              setHouseBuildEditMode(true); //棟別集體 新增/刪除 模式 reset
              setHouseBuild([]); //Clear 棟別編輯 Array
              setEditAuthGroupStage({}); //Dialog render Data
              setHouseAuthDialog(false); //Dialog UI control
            }}
          >
            <Form>
              <h2>
                {editAuthGroupStage.hasOwnProperty('_id')
                  ? editAuthGroupStage.householdNumber + '-權限編輯'
                  : '棟別綁定權限'}
                {!editAuthGroupStage.hasOwnProperty('_id') ? (
                  <span>
                    <span>
                      {houseBuildEditMode ? ' - (新增模式)' : ' - (刪除模式)'}
                    </span>
                    {houseBuildEditMode ? (
                      <Button
                        onClick={() => {
                          setHouseBuildEditMode(false);
                        }}
                      >
                        切換至集體刪除
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          setHouseBuildEditMode(true);
                        }}
                      >
                        切換至集體新增
                      </Button>
                    )}
                  </span>
                ) : null}
              </h2>
              {!editAuthGroupStage.hasOwnProperty('_id') ? (
                <p className={styles.popInfo}>
                  根據所選相同裝置名稱,相關[樓層]資料將一併被(取代/刪除)
                </p>
              ) : null}
              <Item
                label={
                  editAuthGroupStage.hasOwnProperty('_id')
                    ? '權限群組名稱'
                    : '目標棟別'
                }
              >
                {editAuthGroupStage.hasOwnProperty('_id') ? (
                  //編輯當戶
                  <Input
                    name="keyWord"
                    defaultValue={
                      editAuthGroupStage.hasOwnProperty('_id')
                        ? editAuthGroupStage.householdNumber
                        : ''
                    }
                    disabled={true}
                    placeholder="請輸入名稱"
                  />
                ) : (
                  //棟別群體設定權限
                  <Select
                    mode="multiple"
                    className={styles.minWd}
                    size="large"
                    placeholder="請選擇棟別"
                    // dataSource={parseHouseBuild()}
                    onChange={(value) => {
                      setHouseBuild(value);
                    }}
                  >
                    {newOutArr.map((item, index) => (
                      <Option value={item.value} key={index}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Item>

              <Item label="選擇權限群組">
                <Select
                  mode="multiple"
                  className={styles.minWd}
                  size="large"
                  placeholder="請選擇群組"
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('cardGroups')
                      ? editAuthGroupStage.cardGroups
                      : []
                  }
                  value={
                    editAuthGroupStage.hasOwnProperty('cardGroups')
                      ? editAuthGroupStage.cardGroups
                      : []
                  }
                  dataSource={[...cardGroupDataArr].map((i) => {
                    let obj = {};
                    obj.label = i.name;
                    obj.value = i.name;
                    return obj;
                  })}
                  onChange={(value) => {
                    console.log('群組 +++++++++ +::', value);

                    let newObj = Object.assign(
                      {},
                      JSON.parse(JSON.stringify(editAuthGroupStage))
                    );
                    if (!newObj.hasOwnProperty('doorAllows'))
                      newObj.doorAllows = [];
                    if (!newObj.hasOwnProperty('doorAllowsObj'))
                      newObj.doorAllowsObj = {};
                    if (!newObj.hasOwnProperty('elevatorAllows'))
                      newObj.elevatorAllows = [];
                    if (!newObj.hasOwnProperty('elevatorAllowsObj'))
                      newObj.elevatorAllowsObj = {};

                    newObj.cardGroups = value;

                    const tarCardGPArr = cardGroupDataArr.filter((i) => {
                      return value.includes(i.name);
                    });
                    tarCardGPArr.forEach((e) => {
                      //群組權限 加入到 Dialog render Data
                      e.doorAllows.forEach((ee) => {
                        if (!newObj.doorAllows.includes(ee)) {
                          newObj.doorAllows.push(ee);
                          newObj.doorAllowsObj[ee] = e.doorAllowsObj[ee];
                        }
                      });

                      e.elevatorAllows.forEach((ee) => {
                        if (!newObj.elevatorAllows.includes(ee)) {
                          newObj.elevatorAllows.push(ee);
                          newObj.elevatorAllowsObj[ee] =
                            e.elevatorAllowsObj[ee];
                        }
                      });
                    });

                    // console.log(newObj);
                    setEditAuthGroupStage(newObj);
                  }}
                  onRemove={(value) => {
                    //權限群組選擇[移除]
                    let newObj = Object.assign(
                      {},
                      JSON.parse(JSON.stringify(editAuthGroupStage))
                    );
                    const tarCardGPArr = cardGroupDataArr.filter((i) => {
                      return i.name === value.value;
                    });
                    if (tarCardGPArr.length > 0) {
                      newObj.cardGroups.splice(
                        newObj.cardGroups.indexOf(value.value),
                        1
                      ); //cardGroup Data移除
                      let commonDoor = [];
                      let commonElevator = [];
                      //移除 該權限群組有的值
                      if (
                        tarCardGPArr[0].hasOwnProperty('doorAllowsObj') &&
                        newObj.hasOwnProperty('doorAllowsObj')
                      ) {
                        Object.keys(tarCardGPArr[0].doorAllowsObj).forEach(
                          (e) => {
                            if (newObj.doorAllowsObj.hasOwnProperty(e)) {
                              delete newObj.doorAllowsObj[e];
                              commonDoor.push(e);
                            }
                          }
                        );
                      }
                      //移除 該權限群組有的值 (電梯:有相同key & 判斷裡面floor一樣就移除 )
                      if (
                        tarCardGPArr[0].hasOwnProperty('elevatorAllowsObj') &&
                        newObj.hasOwnProperty('elevatorAllowsObj')
                      ) {
                        Object.keys(tarCardGPArr[0].elevatorAllowsObj).forEach(
                          (e) => {
                            if (newObj.elevatorAllowsObj.hasOwnProperty(e)) {
                              if (
                                tarCardGPArr[0].elevatorAllowsObj[e].floor ==
                                newObj.elevatorAllowsObj[e].floor
                              ) {
                                //(電梯:有相同key & 判斷裡面floor一樣就移除 )
                                delete newObj.elevatorAllowsObj[e];
                                commonElevator.push(e);
                              }
                            }
                          }
                        );
                      }
                      if (
                        tarCardGPArr[0].hasOwnProperty('doorAllows') &&
                        newObj.hasOwnProperty('doorAllows')
                      ) {
                        //移除 doorArr
                        commonDoor.forEach((e) => {
                          if (newObj.doorAllows.includes(e))
                            newObj.doorAllows.splice(
                              newObj.doorAllows.indexOf(e),
                              1
                            );
                        });
                      }
                      if (
                        tarCardGPArr[0].hasOwnProperty('elevatorAllows') &&
                        newObj.hasOwnProperty('elevatorAllows')
                      ) {
                        //移除 elevatorArr
                        commonElevator.forEach((e) => {
                          if (newObj.elevatorAllows.includes(e))
                            newObj.elevatorAllows.splice(
                              newObj.elevatorAllows.indexOf(e),
                              1
                            );
                        });
                      }
                      setEditAuthGroupStage(newObj);
                    }
                  }}
                >
                  {cardGroupDataArr.map((item, index) => (
                    <Option value={item.name} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Item>

              <Item label="門禁通行裝置">
                <Select
                  mode="multiple"
                  className={styles.minWd}
                  size="large"
                  placeholder="請選擇裝置"
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('doorAllowsObj')
                      ? editAuthGroupStage.doorAllows
                      : []
                  }
                  // dataSource={baDeviceArr}
                  value={
                    editAuthGroupStage.hasOwnProperty('doorAllowsObj')
                      ? editAuthGroupStage.doorAllows
                      : []
                  }
                  onChange={(value) => {
                    // console.log(value);
                    let newObj = Object.assign(
                      {},
                      JSON.parse(JSON.stringify(editAuthGroupStage))
                    );
                    if (!newObj.hasOwnProperty('doorAllows'))
                      newObj.doorAllows = [];
                    if (!newObj.hasOwnProperty('doorAllowsObj'))
                      newObj.doorAllowsObj = {};
                    newObj.doorAllows = value;

                    let textObj = {};
                    value.forEach((i) => {
                      baDeviceArr.forEach((e) => {
                        if (e.value == i) textObj[i] = e.label;
                      });
                      return textObj;
                    });
                    newObj.doorAllowsObj = textObj;

                    setEditAuthGroupStage(newObj);
                  }}
                >
                  {baDeviceArr.map((item, index) => (
                    <Option value={item.value} key={index}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Item>
              <Item label="電梯通行裝置">
                <Select
                  mode="multiple"
                  className={styles.minWd}
                  size="large"
                  placeholder="請選擇裝置"
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('elevatorAllowsObj')
                      ? editAuthGroupStage.elevatorAllows
                      : []
                  }
                  value={
                    editAuthGroupStage.hasOwnProperty('elevatorAllowsObj')
                      ? editAuthGroupStage.elevatorAllows
                      : []
                  }
                  dataSource={baDeviceEleArr}
                  onChange={(value) => {
                    console.log(value);
                    let newObj = Object.assign({}, editAuthGroupStage);
                    if (!newObj.hasOwnProperty('elevatorAllows'))
                      newObj.elevatorAllows = [];
                    newObj.elevatorAllows = value;

                    let textObj = {};
                    value.forEach((i) => {
                      baDeviceEleArr.forEach((e) => {
                        if (e.value == i) {
                          if (
                            !newObj.hasOwnProperty('elevatorAllowsObj') ||
                            !newObj.elevatorAllowsObj.hasOwnProperty(i)
                          ) {
                            //新增樓層 key
                            textObj[i] = {};
                            textObj[i].name = e.label;
                            textObj[i].floor = '';
                          } else {
                            textObj[i] = newObj.elevatorAllowsObj[i]; //原本就在的樓層 key
                          }
                        }
                      });
                      return textObj;
                    });
                    newObj.elevatorAllowsObj = textObj;

                    setEditAuthGroupStage(newObj);
                  }}
                >
                  {baDeviceEleArr.map((item, index) => (
                    <Option value={item.value} key={index}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Item>

              {editAuthGroupStage.hasOwnProperty('elevatorAllowsObj') &&
              houseBuildEditMode
                ? editAuthGroupStage.elevatorAllows.map((e, nb) => {
                    return (
                      <Item
                        label={
                          houseBuildEditMode
                            ? '電梯裝置通行樓層(例如:B1,1)'
                            : null
                        }
                        key={nb}
                      >
                        <div>
                          <span>
                            {editAuthGroupStage.elevatorAllowsObj.hasOwnProperty(
                              e
                            )
                              ? editAuthGroupStage.elevatorAllowsObj[e].name
                              : e}
                          </span>
                          <Input
                            name="keyWord"
                            placeholder="輸入樓層(eg:B1,1)"
                            defaultValue={
                              editAuthGroupStage.elevatorAllowsObj[e].floor
                                ? editAuthGroupStage.elevatorAllowsObj[e].floor
                                : ''
                            }
                            value={
                              editAuthGroupStage.elevatorAllowsObj[e].floor
                                ? editAuthGroupStage.elevatorAllowsObj[e].floor
                                : ''
                            }
                            onChange={(value) => {
                              console.log('onChange', value);
                              // addHouseBuildDataParse();
                              removeHouseBuildDataParse();
                              let newObj = Object.assign(
                                {},
                                editAuthGroupStage
                              );
                              newObj.elevatorAllowsObj[e].floor = value;
                              setEditAuthGroupStage(newObj);
                            }}
                          />
                        </div>
                      </Item>
                    );
                  })
                : null}
            </Form>
          </Dialog>
        </div>
      ) : (
        //群組權限編輯
        <div>
          <Button
            onClick={() => {
              setEditMode(true);
              setEditAuthGroupStage({}); //clear Dialog render Data
              setAuthGroupDialog(false); //Dialog UI control
              setHouseAuthDialog(false); //Dialog UI control
            }}
          >
            住戶權限模式
          </Button>

          <Button
            onClick={() => {
              setEditAuthGroupStage({}); //clear Dialog render Data
              setAuthGroupDialog(true);
            }}
          >
            新增權限群組
          </Button>

          {/* 顯示群組權限列表區 */}
          <Table dataSource={cardGroupDataArr}>
            <Table.Column
              title="名稱"
              width={60}
              cell={(record, index) => {
                return <>{cardGroupDataArr[index].name}</>;
              }}
            />
            <Table.Column
              title="門禁權限"
              width={160}
              cell={(record, index) => {
                return (
                  <>
                    {cardGroupDataArr[index].doorAllows
                      ? cardGroupDataArr[index].doorAllows.map((list, ii) => {
                          return (
                            <p key={ii}>
                              {cardGroupDataArr[index].doorAllowsObj[list] ||
                                list}
                            </p>
                            // <p key={index}>{list}</p>
                          );
                        })
                      : ''}
                  </>
                );
              }}
            />
            <Table.Column
              title="電梯權限"
              width={160}
              cell={(record, index) => {
                return (
                  <>
                    {cardGroupDataArr[index].elevatorAllows
                      ? cardGroupDataArr[index].elevatorAllows.map(
                          (list, ii) => {
                            return (
                              <p key={ii}>
                                {cardGroupDataArr[index].elevatorAllowsObj[list]
                                  .name || list}
                              </p>
                              // <p key={index}>{list}</p>
                            );
                          }
                        )
                      : ''}
                  </>
                );
              }}
            />
            <Table.Column
              title="操作"
              width={60}
              lock="right"
              cell={(value, index, record) => {
                // console.log('==op ', value, index, record);
                return (
                  <div className={styles.btn}>
                    <Button
                      type="normal"
                      onClick={() => {
                        setEditAuthGroupStage(cardGroupDataArr[index]);
                        setAuthGroupDialog(true);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="normal"
                      onClick={() => {
                        Swal.fire({
                          title: `確定刪除此群組(${cardGroupDataArr[index].name})?`,
                          text: `請先確定住戶權限中沒有套用此群組之設定\n(建議先在[住戶權限]使用刪除模式移除${cardGroupDataArr[index].name}權限住戶再刪除)\n刪除後將無法復原!`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            cardManagementGroup
                              .remove(cardGroupDataArr[index]._id)
                              .then(() => {
                                const newCardGroupDataArr =
                                  cardGroupDataArr.filter(
                                    (i) => i._id !== cardGroupDataArr[index]._id
                                  );
                                setCardGroupDataArr(newCardGroupDataArr);
                                Swal.fire(
                                  '刪除!',
                                  '此權限群組已刪除',
                                  'success'
                                );
                              })
                              .catch((err) => {
                                Swal.fire(
                                  '發生錯誤!',
                                  err.message || err,
                                  'error'
                                );
                              });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            ></Table.Column>
          </Table>

          {/* 編輯門禁群組popup */}
          <Dialog
            hasMask
            className={styles.dialog}
            visible={authGroupDialog}
            onOk={() => {
              if (!editAuthGroupStage.hasOwnProperty('name')) {
                Swal.fire('錯誤!', '名稱欄位不得為空', 'error');
                return;
              } else if (
                !editAuthGroupStage.hasOwnProperty('doorAllows') &&
                !editAuthGroupStage.hasOwnProperty('elevatorAllows')
              ) {
                Swal.fire('錯誤!', '門禁與電梯權限欄位不能都為空', 'error');
                return;
              }

              if (editAuthGroupStage.hasOwnProperty('_id')) {
                //PATCH
                Swal.fire({
                  title: `確定編輯此群組?`,
                  text: '如果住戶權限中有套用此群組設定之住戶,如有多個群組設定到相同裝置名稱,該裝置權限將被此權限群組設定覆蓋!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  //pop ask edit or not
                  if (result.isConfirmed) {
                    //同意編輯
                    const tId = editAuthGroupStage._id;
                    delete editAuthGroupStage._id;
                    cardManagementGroup
                      .patch(tId, editAuthGroupStage)
                      .then((data) => {
                        const newCardGroupDataArr = [...cardGroupDataArr] //前端表格渲染 更新
                          .map((i) => {
                            if (i._id == data._id) {
                              return data;
                            }
                            return i;
                          });
                        console.log(newCardGroupDataArr);
                        setCardGroupDataArr(newCardGroupDataArr);
                        setEditAuthGroupStage({}); //Dialog render Data
                        setAuthGroupDialog(false); //Dialog UI control
                        Swal.fire('修改成功!', '此權限群組修改成功', 'success');
                      })
                      .catch((err) => {
                        Swal.fire('發生錯誤!', err.message || err, 'error');
                      });
                  }
                });
                return;
              }

              Swal.fire({
                title: `確定建立此群組?`,
                text: '權限群組名稱建立後無法修改,請確認後送出!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#BEBEBE',
                confirmButtonText: '送出',
                cancelButtonText: '取消',
              }).then((result) => {
                //pop ask edit or not
                if (result.isConfirmed) {
                  //同意編輯
                  cardManagementGroup
                    .create(editAuthGroupStage) //CREATE
                    .then((data) => {
                      const newCardGroupDataArr = [...cardGroupDataArr].concat(
                        data
                      ); //前端表格渲染 更新
                      setCardGroupDataArr(newCardGroupDataArr);
                      setEditAuthGroupStage({}); //Dialog render Data
                      setAuthGroupDialog(false); //Dialog UI control
                      Swal.fire('建立成功!', '此權限群組建立成功', 'success');
                    })
                    .catch((err) => {
                      Swal.fire('發生錯誤!', err.message || err, 'error');
                    });
                }
              });
            }}
            onCancel={() => {
              setEditAuthGroupStage({}); //Dialog render Data
              setAuthGroupDialog(false); //Dialog UI control
            }}
            onClose={() => {
              setEditAuthGroupStage({}); //Dialog render Data
              setAuthGroupDialog(false); //Dialog UI control
            }}
          >
            <Form>
              <h2>
                {editAuthGroupStage.hasOwnProperty('_id')
                  ? '權限群組編輯-' + editAuthGroupStage.name
                  : '新增權限群組'}
              </h2>
              <Item label="權限群組名稱">
                <Input
                  name="keyWord"
                  disabled={
                    editAuthGroupStage.hasOwnProperty('_id') ? true : false
                  }
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('_id')
                      ? editAuthGroupStage.name
                      : ''
                  }
                  placeholder="請輸入名稱"
                  onChange={(value) => {
                    let newObj = Object.assign({}, editAuthGroupStage);
                    newObj.name = value;
                    setEditAuthGroupStage(newObj);
                  }}
                />
              </Item>
              <Item label="門禁通行裝置">
                <Select
                  mode="multiple"
                  className={styles.minWd}
                  size="large"
                  placeholder="請選擇裝置"
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('_id')
                      ? editAuthGroupStage.doorAllows
                      : []
                  }
                  dataSource={baDeviceArr}
                  onChange={(value) => {
                    console.log(value);
                    let newObj = Object.assign({}, editAuthGroupStage);
                    if (!newObj.hasOwnProperty('doorAllows'))
                      newObj.doorAllows = [];
                    newObj.doorAllows = value;

                    let textObj = {};
                    value.forEach((i) => {
                      baDeviceArr.forEach((e) => {
                        if (e.value == i) textObj[i] = e.label;
                      });
                      return textObj;
                    });
                    newObj.doorAllowsObj = textObj;

                    setEditAuthGroupStage(newObj);
                  }}
                >
                  {baDeviceArr.map((item, index) => (
                    <Option value={item.value} key={index}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Item>
              <Item label="電梯通行裝置">
                <Select
                  mode="multiple"
                  className={styles.minWd}
                  size="large"
                  placeholder="請選擇裝置"
                  defaultValue={
                    editAuthGroupStage.hasOwnProperty('_id')
                      ? editAuthGroupStage.elevatorAllows
                      : []
                  }
                  dataSource={baDeviceEleArr}
                  onChange={(value) => {
                    console.log(value);
                    let newObj = Object.assign({}, editAuthGroupStage);
                    if (!newObj.hasOwnProperty('elevatorAllows'))
                      newObj.elevatorAllows = [];
                    newObj.elevatorAllows = value;

                    let textObj = {};
                    value.forEach((i) => {
                      baDeviceEleArr.forEach((e) => {
                        if (e.value == i) {
                          if (
                            !newObj.hasOwnProperty('elevatorAllowsObj') ||
                            !newObj.elevatorAllowsObj.hasOwnProperty(i)
                          ) {
                            //新增樓層 key
                            textObj[i] = {};
                            textObj[i].name = e.label;
                            textObj[i].floor = '';
                          } else {
                            textObj[i] = newObj.elevatorAllowsObj[i]; //原本就在的樓層 key
                          }
                        }
                      });
                      return textObj;
                    });
                    newObj.elevatorAllowsObj = textObj;

                    setEditAuthGroupStage(newObj);
                  }}
                >
                  {baDeviceEleArr.map((item, index) => (
                    <Option value={item.value} key={index}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Item>

              {editAuthGroupStage.hasOwnProperty('elevatorAllowsObj')
                ? editAuthGroupStage.elevatorAllows.map((e, nb) => {
                    return (
                      <Item label="電梯裝置通行樓層" key={nb}>
                        <div>
                          <span>
                            {editAuthGroupStage.elevatorAllowsObj.hasOwnProperty(
                              e
                            )
                              ? editAuthGroupStage.elevatorAllowsObj[e].name
                              : e}
                          </span>
                          <Input
                            name="keyWord"
                            placeholder="輸入樓層(eg:B1,1)"
                            defaultValue={
                              editAuthGroupStage.elevatorAllowsObj[e].floor
                                ? editAuthGroupStage.elevatorAllowsObj[e].floor
                                : ''
                            }
                            onChange={(value) => {
                              console.log('onChange', value);
                              let newObj = Object.assign(
                                {},
                                editAuthGroupStage
                              );
                              newObj.elevatorAllowsObj[e].floor = value;
                              console.log('Nooooooooooooob');
                              console.log(newObj);
                              setEditAuthGroupStage(newObj);
                              console.log(editAuthGroupStage);
                            }}
                          />
                        </div>
                      </Item>
                    );
                  })
                : null}
            </Form>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default ResidentBaAuthList;
